module.exports = __webpack_public_path__ + "static/media/thumbnail.2311dd22.webp";